import { jsx as _jsx } from "react/jsx-runtime";
import { Auth } from '@aws-amplify/auth';
import { KinesisVideoClient } from '@aws-sdk/client-kinesis-video';
import { getSingleNodeEdgeMapperQuery, VideoHub, VideoHubClassName, VideoStream, VideoStreamClassName, } from '@iotv/datamodel-core';
import { isVOBofType } from '@iotv/iotv-v3-types';
import { Alert, Stack } from '@mui/material';
import { Environment } from 'internal-config';
import { useContext, useEffect, useMemo, useReducer } from 'react';
import { DetailsTab } from '../../components/VideoStream/tabs/DetailsTab/VideoStreamDetailsTab';
import { VideoMonitorTab } from '../../components/VideoStream/tabs/Media/VideoMonitorTab';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { getPulseSX } from '../../cosmetics/sx';
import { ConsumerDao } from '../../data/ConsumerDAO/consumerDAO';
import ObjectCard from '../../v2/components/generic/ObjectView/ObjectCard';
import { defaultState, KinesisVideoStreamContext } from './Context/KinesisVideoStreamContext';
const debug = process.env.REACT_APP_DEBUG && true;
const { region } = Environment;
export const VideoStreamCard = ({ initialEditMode, transactionFunctions, viewObject }) => {
    console.log(`VideoStreamCard rerender`);
    const [{ UserFunctions }, appDispatch] = useContext(AppMainViewContext);
    const DefaultReducer = (prev, next) => ({ ...prev, ...next });
    const [state, dispatch] = useReducer(DefaultReducer, defaultState);
    const setKVClient = async () => {
        const credentials = await Auth.currentUserCredentials();
        const kvClient = new KinesisVideoClient({ region, credentials });
        console.log('KinesisVideoClient initialized:', kvClient);
        dispatch({ kvClient });
    };
    const getSingleApexNodeEdgeMapper = async ({ item }) => {
        const query = getSingleNodeEdgeMapperQuery({ item });
        return await ConsumerDao.getGraphQueryRequestV2({
            contextObjects: [item],
            query,
        });
    };
    useEffect(() => {
        const fetchData = async () => {
            if (viewObject.matchedPrimary) {
                const { err, data: nodeEdgeMapper } = await getSingleApexNodeEdgeMapper({ item: viewObject.matchedPrimary });
                if (err) {
                    console.error('Error fetching node edge mapper:', err);
                    return;
                }
                UserFunctions.addObjectsToState(nodeEdgeMapper?.getContainedNodesAndEdges() ?? []);
                const videoHubs = nodeEdgeMapper?.getNodesOfType(VideoHubClassName) ?? [];
                const videoStreams = nodeEdgeMapper?.getNodesOfType(VideoStreamClassName) ?? [];
                if (videoHubs.length > 0) {
                    if (videoHubs.length > 1) {
                        console.log('Multiple VideoHubs found for the VideoStream. Using the first one.');
                    }
                    if (videoStreams.length > 0) {
                        if (videoStreams.length > 1) {
                            console.log('Multiple VideoStreams found for the VideoHub. Using the first one.');
                        }
                        const videoHub = new VideoHub(videoHubs[0]);
                        const videoStream = new VideoStream(videoStreams[0]);
                        dispatch({ VideoHub: videoHub, VideoStream: videoStream });
                    }
                    else {
                        console.warn('No VideoStreams found for the VideoHub.');
                    }
                }
            }
        };
        const update = {};
        if (!state.kvClient)
            setKVClient();
        if (isVOBofType(VideoStreamClassName, viewObject.matchedPrimary)) {
            update.VideoStream = new VideoStream(viewObject.matchedPrimary);
        }
        const providedHub = viewObject.matchedRelatedByPk?.find((obj) => isVOBofType(VideoHubClassName, obj));
        if (providedHub) {
            update.VideoHub = new VideoHub(providedHub);
        }
        else {
            fetchData();
        }
        if (Object.keys(update).length > 0) {
            dispatch(update);
        }
    }, [viewObject.matchedPrimary?.sk,]);
    const providerValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
    const additionalTabs = useMemo(() => ({ Details: DetailsTab, Media: VideoMonitorTab }), []);
    const { matchedPrimary } = viewObject;
    if (!matchedPrimary) {
        return _jsx(Alert, { severity: 'info', sx: getPulseSX({ animationDuration: 1 }), children: "Waiting for data..." });
    }
    return (_jsx(KinesisVideoStreamContext.Provider, { value: providerValue, children: _jsx(Stack, { direction: "column", spacing: 2, sx: { width: '100%' }, children: _jsx(ObjectCard, { initialEditMode,
                transactionFunctions,
                viewObject,
                additionalTabs }) }) }));
};
